import * as VueRouter from 'vue-router';

// Stores
import {useAuthStore} from "./Stores/AuthStore";

// Layouts
const LoginPage = () => import('./Layouts/LoginPage.vue');
const RegisterPage = () => import('./Layouts/RegisterPage.vue');
const AdminLayout = () => import('./Layouts/AdminLayout.vue');
// Pages
const Dashboard = () => import('./Pages/Dashboard.vue');
const QRCodeReader = () => import('./Pages/QRCodeReader.vue');
const DefaultSettings = () => import('./Pages/DefaultSettings.vue');
const EmailTemplateSettings = () => import('./Pages/EmailTemplateSettings.vue');
const NotificationsSettings = () => import('./Pages/NotificationsSettings.vue');
const CalendarView = () => import('./Pages/CalendarView.vue');
const Admins = () => import('./Pages/Admins.vue');
const Tickets = () => import('./Pages/Tickets.vue');
const GiftVouchers = () => import('./Pages/GiftVouchers.vue');
const PurchasedGiftVouchers = () => import('./Pages/PurchasedGiftVouchers.vue');
const GiftVoucherReader = () => import('./Pages/GiftVoucherReader.vue');
const Bookings = () => import('./Pages/Bookings.vue');
const AppointmentTimes = () => import('./Pages/AppointmentTimes.vue');
const AppointmentsCapacityIncrease = () => import('./Pages/AppointmentsCapacityIncrease.vue');
const Languages = () => import('./Pages/Languages.vue');
const Translations = () => import('./Pages/Translations.vue');

const routes = [
	{
		path: '/login',
		name: 'login',
		component: LoginPage,
	},
	{
		path: '/register',
		name: "register",
		component: RegisterPage,
	},
	{
		path: '/',
		component: AdminLayout,
		meta: {
			auth: true
		},
		children: [
			{
				path: '/dashboard',
				name: 'dashboard',
				component: Dashboard,
			},
			{
				path: '/qrcode-reader',
				name: 'qrcode-reader',
				component: QRCodeReader,
			},
			{
				path: '/default-settings',
				name: 'default-settings',
				component: DefaultSettings,
			},
			{
				path: '/admins',
				name: 'admins',
				component: Admins,
			},
			{
				path: '/emails',
				name: 'email-template-settings',
				component: EmailTemplateSettings,
			},
			{
				path: '/notifications',
				name: 'notifications-settings',
				component: NotificationsSettings,
			},
			{
				path: '/calendar',
				name: 'calendar-settings',
				component: CalendarView,
			},
			{
				path: '/tickets',
				name: 'tickets',
				component: Tickets,
			},
			{
				path: '/gift-vouchers',
				name: 'gift-vouchers',
				component: GiftVouchers,
			},
			{
				path: '/purchased-gift-vouchers',
				name: 'purchased-gift-vouchers',
				component: PurchasedGiftVouchers,
			},
			{
				path: '/gift-voucher-reader',
				name: 'gift-voucher-reader',
				component: GiftVoucherReader,
			},
			{
				path: '/bookings',
				name: 'bookings',
				component: Bookings,
			},
			{
				path: '/appointment-times',
				name: 'appointment-times',
				component: AppointmentTimes,
			},
			{
				path: '/appointments-capacity-increase',
				name: 'appointments-capacity-increase',
				component: AppointmentsCapacityIncrease,
			},
			{
				path: '/languages',
				name: 'languages',
				component: Languages,
			},
			{
				path: '/translations',
				name: 'translations',
				component: Translations,
			},
		]
	},
	{path: '/:pathMatch(.*)*', name: '404', redirect: '/'},
]

const router = VueRouter.createRouter({
	history: VueRouter.createWebHistory(),
	routes,
});

router.beforeEach(async (to, from, next) => {
	const store = useAuthStore();

	if ((to.name !== 'login' && to.name !== 'register') && !store.isLoggedIn) {
		next({name: "login"});
	} else if ((to.name === 'login' || to.name === 'register') && store.isLoggedIn) {
		next({name: 'dashboard'});
	} else if (store.isLoggedIn === false && to.meta.auth === true) {
		await Sweetalert2.fire({
			title: 'Kérlek jelentkezz be az oldal megtekintéséhez!',
			icon: 'warning',
			confirmButtonText: 'OK'
		});
		await router.push({name: 'home'});
		return;
	}
	if (store.isLoggedIn && !store.isLoaded) {
		await store.getMe();
	}
	next();
});
export default router;
